import React from 'react';
import { useLoginSettings } from '../contexts/loginSettingsContext';
import useDarkMode from '../hooks/useDarkMode';

// Accept size props so Brand can control alignment and responsive sizing
const Logo = ({ width = 110, height = 32 }) => {
	const { loginSettings } = useLoginSettings();
	const { darkModeStatus } = useDarkMode();
	return (
		<img
			style={{ width: `${width}px`, height: `${height}px`, objectFit: 'contain' }}
			src={darkModeStatus ? loginSettings.site_logo_dark : loginSettings.site_logo}
			alt='Site Logo'
		/>
	);
};
Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
